import React from 'react';
import { Box, Button, Checkbox, FormControlLabel, Typography } from '@mui/material';

export const PropertyChecklist = () => {
    // const [checkedItems, setCheckedItems] = useState({
    //     title: true,
    //     ownership: true,
    //     lotPlan: false,
    //     taxDeclaration: true,
    //     spa: false,
    //     attorney: true,
    //     ownerID: true,
    //     commission: true,
    // });

    // const handleChange = (event) => {
    //     setCheckedItems({
    //         ...checkedItems,
    //         [event.target.name]: event.target.checked,
    //     });
    // };

    return (
        <Box mt={2} display="flex" alignItems="center" flexDirection="column" gap={2}>
            <Typography width="100%" variant="body1" fontWeight={550} color="text.primary">
                Property Checklist
            </Typography>
            <Box width="100%" height="100%">
                {[
                    { label: 'Original Certificate of Title/ Transfer Certificate of Title', name: 'title' },
                    { label: 'Certificate of Land Ownership Awards', name: 'ownership' },
                    { label: 'Lot Plan', name: 'lotPlan' },
                    { label: 'Tax Declaration', name: 'taxDeclaration' },
                    { label: 'SPA', name: 'spa' },
                    { label: 'ID of the Attorney-In-Fact', name: 'attorney' },
                    { label: 'ID of the Owner', name: 'ownerID' },
                ].map((item) => (
                    <FormControlLabel sx={{ width: "100%" }}
                        key={item.name}
                        control={<Checkbox
                            // checked={checkedItems[item.name]}
                            checked={true}
                        />}
                        disabled
                        label={<Typography sx={{ fontSize: 14 }}>{item.label}</Typography>}
                    />
                ))}
            </Box> 
            <FormControlLabel sx={{ ml: "0.75rem" }}
                control={<Checkbox
                    // checked={checkedItems.commission}
                    checked={true}
                    disabled
                    size="small"
                    // onChange={handleChange} 
                    name="commission" />}
                label={<Typography sx={{ fontSize: 12 }}>
                    I agree to pay commission on the sale of my property once it is sold through your services.
                </Typography>}
            />
            <Button variant="contained" color="primary" disabled sx={{ mt: "0.5rem", mb: "1rem" }}>
                Submit Property
            </Button>
        </Box>
    );
};
